import {VariantProps} from 'cva';
import React from 'react';
import {cva, styles} from '../../../Utilities/defineStyles';

export function FieldLayout({
    label,
    isInvalid = false,
    isDisabled = false,
    decoration,
    decorationSize,
    issue,
    helperText,
    children,
}: React.PropsWithChildren<FieldLayout.Props>) {
    if (issue) {
        helperText = issue;
        isInvalid = true;
    }
    return (
        <div className={`${cls.root} ${!isDisabled && isInvalid ? '~Field__root--invalid' : ''}`}>
            {label}
            <div className={cls.innerBox}>
                {children}
                <span className={cls.decor({size: decorationSize})}>{decoration}</span>
            </div>
            <span className={cls.helper}>{helperText}</span>
        </div>
    );
}

export const cls = styles({
    decor: cva('~Field__decor', {
        variants: {
            size: {
                default: '~Field__decor--default',
                big: '~Field__decor--big',
            },
        },
        defaultVariants: {
            size: 'default',
        },
    }),
    innerBox: '~Field__innerBox',
    root: '~Field__root',
    helper: '~Field__helper',
});

export namespace FieldLayout {
    export interface Props {
        label?: React.ReactNode;
        decoration?: React.ReactNode;
        decorationSize?: VariantProps<typeof cls.decor>['size'];
        issue?: React.ReactNode | undefined;
        helperText?: React.ReactNode;
        isInvalid?: boolean | undefined;
        isDisabled?: boolean | undefined;
    }
}
